/* A roster of invented companies. These are deliberately NOT real brands:
   the portfolio pieces carry their own names, and this list stands for the
   wider book of work that never gets published. */
export const clients = [
    { name: 'Aurelle', sector: 'Fine Jewellery', since: '2019', work: 'Identity, Web' },
    { name: 'Northbound', sector: 'Outdoor', since: '2021', work: 'Art Direction' },
    { name: 'Sable & Co', sector: 'Interiors', since: '2017', work: 'Identity, Print' },
    { name: 'Vessel', sector: 'Fragrance', since: '2023', work: 'Brand, Packaging' },
    { name: 'Ardent', sector: 'Performance', since: '2020', work: 'Web, Motion' },
    { name: 'Halden', sector: 'Menswear', since: '2015', work: 'Identity, Web' }
]
